import { Col, DatePicker, Form, Input, Radio, Row } from 'antd'
import useFetchSelect from '../../../elements/Hooks/useFetchSelect'
import CustomSpin from '../../../elements/CustomSpin'
import DeliveryDetails from '../../../elements/DeliveryDetails'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import withSpinning from '../../../elements/HOC/withSpinning'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import CustomDebounceSelect from '../../../elements/Select/CustomDebounceSelect'
import withUrlFetch from '../../../elements/Select/withUrlFetch'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../modules/FormItems'
import { dateVal, strVal } from '../../../modules/Utils'
import moment from 'moment'
import React, { useEffect } from 'react'

import { compose } from 'recompose'

const VendorSelect = compose(
  withUrlFetch({
    name: 'members',
    url: `members/list/organisation`,
  }),
  withSpinning
)(CustomDebounceSelect)

function DeliveryOrderForm(props) {
  const { delivery, fetching } = props

  const { getFieldValue, setFieldsValue, getFieldDecorator, resetFields } = props.form

  const [BudgetSelect] = useFetchSelectUrl({
    name: 'budgets',
    url: `budgets/?dropdown=true&select=*&status=Approved`,
    cache: false,
  })

  const company = (getFieldValue('company._id') || get(delivery, 'company._id') || '').replace('members/', '')

  const { SelectData: LogisticContractSelect, data: logisticContracts } = useFetchSelect({
    url: `/purchaseContracts/company/${company}?type=logistics`,
    dependencyArray: [company],
    dontFetch: isEmpty(company),
    mapFunction: (i) => ({
      ...i,
      display: `${i.default ? '[Default]' : ''} ${i.title} - ${i.owner.fn} `,
    }),
  })

  useEffect(() => {
    if (logisticContracts && get(delivery, 'company._id') !== getFieldValue('company._id')) {
      const defaultContract = logisticContracts.find((i) => i.default)
      defaultContract && setFieldsValue({ 'logistic._id': defaultContract._id })
    }
  }, [logisticContracts.length, company, getFieldValue('company._id')])

  return (
    <CustomSpin spinning={fetching}>
      <Form>
        <FormSectionTitle title={'Delivery Order Details'} />
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Order Type">
              {getFieldDecorator('orderType', {
                initialValue: get(delivery, 'orderType'),
              })(
                <Radio.Group>
                  <Radio.Button value="Internal">Internal</Radio.Button>
                  <Radio.Button value="Sales">Sales</Radio.Button>
                </Radio.Group>
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Date">
              {getFieldDecorator('date', {
                initialValue: dateVal(delivery, 'date') || moment(),
              })(<DatePicker style={{ width: '100%' }} placeholder="Date" />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Title">
              {getFieldDecorator('title', {
                initialValue: strVal(delivery, 'title'),
              })(<Input placeholder="Title" />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Budget'}>
              {getFieldDecorator('budget._id', {
                initialValue: strVal(delivery, 'budget._id'),
              })(<BudgetSelect keyAtr={'_id'} valueAtr={'title'} />)}
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Logistic Contract">
              {getFieldDecorator('logistic._id', {
                initialValue: strVal(delivery, 'logistic._id'),
                rules: rules.select,
              })(<LogisticContractSelect valueAtr="display" />)}
            </Form.Item>
          </Col>

          {/*  <Col span={12}>*/}
          {/*    <Form.Item {...defaultFormItemLayout} label="Vendor">*/}
          {/*      {getFieldDecorator('vendor._id', {*/}
          {/*        initialValue: get(delivery, 'vendor._id'),*/}
          {/*      })(*/}
          {/*        <VendorSelect*/}
          {/*          keyAtr={'_id'}*/}
          {/*          valueAtr={'fn'}*/}
          {/*          placeholder="Select a Vendor"*/}
          {/*          style={{width: '100%'}}*/}
          {/*        />,*/}
          {/*      )}*/}
          {/*    </Form.Item>*/}
          {/*  </Col>*/}

          {/*  {vendor && (*/}
          {/*    <Col span={12}>*/}
          {/*      <Form.Item {...defaultFormItemLayout} label="Purchase Order">*/}
          {/*        {getFieldDecorator('purchase._id', {*/}
          {/*          initialValue: get(delivery, 'purchase._id'),*/}
          {/*          // rules: rules.select,*/}
          {/*        })(*/}
          {/*          <PurchaseOrderSelect*/}
          {/*            style={{width: purchase ? '80%' : '100%'}}*/}
          {/*            keyAtr={'_id'}*/}
          {/*            valueAtr={'display'}*/}
          {/*            placeholder="Select a Purchase Order"*/}
          {/*          />,*/}
          {/*        )}*/}
          {/*        {purchase && (*/}
          {/*          <Link*/}
          {/*            target={'_blank'}*/}
          {/*            to={`/purchasing/order/${purchase.replace(*/}
          {/*              'purchase/',*/}
          {/*              '',*/}
          {/*            )}/update`}>*/}
          {/*            <Icon style={{marginLeft: 5}} type="fullscreen" />*/}
          {/*          </Link>*/}
          {/*        )}*/}
          {/*      </Form.Item>*/}
          {/*    </Col>*/}
          {/*  )}*/}
        </Row>

        <DeliveryDetails
          doc={delivery}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            hideTitle: false,
            type: 'DeliveryOrder',
            title: 'Delivery Details',
          }}
        />
      </Form>
    </CustomSpin>
  )
}

DeliveryOrderForm.propTypes = {}
DeliveryOrderForm.defaultProps = {}

export default Form.create()(DeliveryOrderForm)
